import { NgModule } from '@angular/core';

import { GLinkSidebarComponent } from './sidebar.component';

@NgModule({
    declarations: [
        GLinkSidebarComponent
    ],
    exports     : [
        GLinkSidebarComponent
    ]
})
export class GLinkSidebarModule
{
}
